import { scopeToSection } from './profileFormDiff';

/**
 * Save of one profile tile. The profile is one mounted form, but Save checks
 * only the fields of the open tile (a required field left empty on another
 * tile does not block it) and submits the form values with every other tile
 * as loaded — the usual "send only what changed" body then carries just this
 * tile.
 *
 * @param {Object} params
 * @param {import('antd').FormInstance} params.form
 * @param {{current: Object|null}} params.baselineRef - values as loaded
 * @param {(name: string[]) => string} params.sectionOfField - field path → tile id
 * @param {string} params.section - the open tile
 * @param {(values: Object, current: Object) => Promise<void>} params.onFinish
 * @param {(info: Object) => void} [params.onFinishFailed]
 * @returns {() => Promise<boolean>} Resolves true when the tile was saved
 */
export default function useProfileTileSave({
  form,
  baselineRef,
  sectionOfField,
  section,
  onFinish,
  onFinishFailed,
}) {
  return async () => {
    const names = form
      .getFieldsError()
      .map(({ name }) => name)
      .filter((name) => sectionOfField(name) === section);
    try {
      if (names.length) await form.validateFields(names);
    } catch (info) {
      if (!info?.errorFields) throw info;
      onFinishFailed?.(info);
      return false;
    }
    const scope = (values) =>
      scopeToSection(values, baselineRef.current, sectionOfField, section);
    try {
      await onFinish(
        scope(form.getFieldsValue()),
        scope(form.getFieldsValue(true))
      );
      return true;
    } catch {
      // The save mutation already showed the error.
      return false;
    }
  };
}
